<template>
  <div v-if="orderReturn.orderReturnIssue.attachments.length > 0">
    <h3 class="order-return-container__section-heading">
      Alla filer i &auml;rendet
    </h3>

    <div class="issue-attachments">
      <a
        v-for="(attachment, attachmentKey) in orderReturn.orderReturnIssue.attachments"
        :key="`attachment-${attachmentKey}`"
        :href="`/mvcapi/se/sv/order-return/attachment-content/${attachment.id}?orderNumber=${order.orderHead.orderNr}`"
        class="issue-attachment">
        <div class="order-return-uploaded-file-icon"><img :src="`/mvcapi/se/sv/order-return/attachment-thumbnail/${attachment.id}?orderNumber=${order.orderHead.orderNr}`"></div>
        <div class="order-return-uploaded-file-name">
          {{ attachment.name }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    orderReturn: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  data: () => ({

  }),
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss">

  .issue-attachments {
    margin-bottom: 1rem;
    border: 1px solid #dfdfdf;
    padding: 1rem;
    display: flex;
    flex-direction: row;
  }

  .issue-attachment {
    display: flex;
    margin-right: .8rem;
    flex-direction: row;
    align-items: center;
    color: color(brand-blue-3);
    display: flex;
    flex-direction: column;

    &:hover {
      cursor: pointer;
    }
  }

  .issue-attachment-icon {
    display: inline-block;
  }

  .issue-attachment-icon > img {
    max-height: 96px;
  }

  .issue-attachment-name {
    margin-left: .5rem;
  }

</style>
